import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Auditlog from '../entities/auditlog'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
interface AuditlogState extends ListState<Auditlog>{
}
class AuditlogModule extends ListModule<AuditlogState,any,Auditlog>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Auditlog>(),
        loading:false
    }
    actions={
        async getPaged(context:ActionContext<AuditlogState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/AuditLog/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Auditlog>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        }

    };
    mutations={
        setCurrentPage(state:AuditlogState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:AuditlogState,pagesize:number){
            state.pageSize=pagesize;
        }
    }
}
const auditlogModule=new AuditlogModule();
export default auditlogModule;